<template>
  <div>
    <section class="user_registration_complete text_center base_text_style">
      <h2 class="header_underline">会員登録完了</h2>
      <p class="text_left">
        そのまま空メールをお送り下さい。折り返し、ご登録の案内をお送りします。
      </p>
      <p class="text_left">
        自動で空メールが起動しない場合、下記の【空メール送信】から起動して下さい。
      </p>
      <p>
        <a :href="`mailto:${createUser.reg_mail}?body=${mailBody}&amp;subject=${mailSubject}`" class="decoration_link">【空メール送信】</a>
      </p>
      <p>
        <router-link to="/" class="decoration_link_arrow_blue">トップページへ戻る</router-link>
      </p>
    </section>
  </div>
</template>

<script>
export default {
  name: 'UserRegistrationComplete',
  data () {
    return {
      createUser: this.$store.getters.createUser || {},
      mailSubject: '空メール会員登録',
      mailBody: 'このまま送信して下さい。'
    }
  },
  mounted: function () {
    window.location.href = 'mailto:' + this.createUser.reg_mail + '?body=' + this.mailBody + '&subject' + this.mailSubject
  }
}
</script>
